export const siteInfo = {
  name: "瓜田速报",
  fullName: "瓜田速报 · 假期事件盘点",
  slogan: "把假期里的热点，按时间顺序讲清楚",
  intro:
    "瓜田速报是一个专注于假期热点复盘的简体中文内容站，围绕五一假期整理被广泛讨论的事件、争议与行业动态。我们只做公开信息的归纳、时间线梳理与背景补充，不复述未经证实的人身指控。",
  email: "contact@guatian-report.com",
  pressEmail: "tips@guatian-report.com",
  slogan2: "观察 · 整理 · 复盘",
  established: "2021 年",
  reportCount: "1,280+",
  categoryCount: "5",
  readerCount: "96 万",
  todayUpdate: "18 条",
  updateTime: "每日 08:00 / 20:00 两更",
};

export const footerGroups = [
  {
    title: "内容板块",
    links: [
      { label: "最新盘点", href: "/topics" },
      { label: "事件时间线", href: "/#timeline" },
      { label: "热门话题榜", href: "/#ranking" },
      { label: "常见问题", href: "/#faq" },
    ],
  },
  {
    title: "主题分类",
    links: [
      { label: "娱乐动态", href: "/topics?cat=yu-le" },
      { label: "影视综", href: "/topics?cat=ying-shi" },
      { label: "品牌营销", href: "/topics?cat=pin-pai" },
      { label: "出行消费", href: "/topics?cat=chu-xing" },
      { label: "社交热点", href: "/topics?cat=she-jiao" },
    ],
  },
  {
    title: "关于本站",
    links: [
      { label: "关于我们", href: "/about" },
      { label: "联系我们", href: "/contact" },
      { label: "内容原则", href: "/about#principle" },
      { label: "订阅速报", href: "/contact#subscribe" },
    ],
  },
];